import * as Sentry from "@sentry/react";
import { getEnv } from "../utils/envManager";
import { buildTraceHeaders } from "@common/sentry/tracing";

export { useAuthHeader } from "../context/AuthContext";

export const webBaseUrl = (): string => getEnv("WEBAPP_API_BASE_URL") ?? "";
export const coreApiV1BaseUrl = (): string => getEnv("API_BASE_URL") ?? "";

export const getTraceHeaders = (): Record<string, string> => buildTraceHeaders(Sentry);
